var _rect, _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBudget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2199",
    "data-name": "Grupo 2199",
    transform: "translate(-25.683 -390.683)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_892",
    "data-name": "Ret\\xE2ngulo 892",
    width: 60,
    height: 60,
    rx: 10,
    transform: "translate(25.683 390.683)",
    fill: "#d3ff9a",
    opacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Iconly_Two-tone_Document",
    "data-name": "Iconly Two-tone Document",
    transform: "translate(38.825 403.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document-8",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke_1-171",
    "data-name": "Stroke 1-171",
    transform: "translate(8.261 23.397)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_349",
    "data-name": "Caminho 349",
    d: "M672.092,554.618H659.56a1.3,1.3,0,1,1,0-2.6h12.532a1.3,1.3,0,1,1,0,2.6Z",
    transform: "translate(-658.258 -552.015)",
    fill: "#d3ff9a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Stroke_2-9",
    "data-name": "Stroke 2-9",
    transform: "translate(8.261 16.132)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_350",
    "data-name": "Caminho 350",
    d: "M672.092,550.432H659.56a1.3,1.3,0,1,1,0-2.6h12.532a1.3,1.3,0,1,1,0,2.6Z",
    transform: "translate(-658.258 -547.829)",
    fill: "#d3ff9a"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Stroke_3-143",
    "data-name": "Stroke 3-143",
    transform: "translate(8.261 8.883)",
    opacity: 0.4,
    style: {
      isolation: "isolate"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_351",
    "data-name": "Caminho 351",
    d: "M664.343,546.255H659.56a1.3,1.3,0,1,1,0-2.6h4.783a1.3,1.3,0,1,1,0,2.6Z",
    transform: "translate(-658.258 -543.652)",
    fill: "#d3ff9a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Stroke_4-11",
    "data-name": "Stroke 4-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_352",
    "data-name": "Caminho 352",
    d: "M662.191,573.116c-.234,0-.486-.01-.74-.031a8.679,8.679,0,0,1-7.921-9.382l-.005-15.857a7.547,7.547,0,0,1-.016-1.105,8.682,8.682,0,0,1,9.144-8.192l13.235,0a9.08,9.08,0,0,1,1.248.019,8.684,8.684,0,0,1,7.907,9.4l.005,15.855a7.381,7.381,0,0,1,.014,1.09,8.685,8.685,0,0,1-9.144,8.193l-13.271,0C662.509,573.11,662.354,573.116,662.191,573.116Zm.029-31.975a6.073,6.073,0,0,0-6.111,5.741,5.753,5.753,0,0,0,.014.847l.005,16.083a6.122,6.122,0,0,0,1.409,4.543,6.04,6.04,0,0,0,4.132,2.136,6.638,6.638,0,0,0,.892.01l13.427,0a6.084,6.084,0,0,0,6.473-5.734,5.881,5.881,0,0,0-.012-.838l-.005-16.076a6.131,6.131,0,0,0-1.4-4.549,6.089,6.089,0,0,0-5.04-2.154c-.024,0-.052,0-.078,0H662.583C662.46,541.143,662.341,541.141,662.221,541.141Z",
    transform: "translate(-653.498 -538.534)",
    fill: "#d3ff9a"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudget);
export default __webpack_public_path__ + "static/media/budget.218e6d300009ea75efd94a900850a807.svg";
export { ForwardRef as ReactComponent };